/*
* 封装菜单组件
*/

import { useState, useEffect } from 'react';
import {
    ProjectOutlined,
    CarOutlined,
    AimOutlined,
    LineChartOutlined,
} from '@ant-design/icons';
import { Menu } from 'antd';
import {
    LogIcon,
} from '../incs/Icons';

function getItem(label, key, icon, children, type) {
    return { key, icon, children, label, type, };
}

function getDefaultOpenKey(m, navItems) {
    let openKeys = [];
    if (navItems) {
        if (m > 100) {
            openKeys.push(navItems[parseInt(m / 100) - 1].sub);
        } else if (m > 10) {
            openKeys.push(navItems[parseInt(m / 10) - 1].sub);
        } else {
            openKeys.push(navItems[parseInt(m) - 1].sub);
        }
    }
    return openKeys;
}

function icon(m, nav) {
    if (nav === 'navItems') {
        switch (m) {
            case 1:
                return <ProjectOutlined />
            case 2:
                return <CarOutlined />
            case 3:
                return <AimOutlined />
            case 4:
                return <LineChartOutlined />
            case 5:
                return <LogIcon />
            default:
                return null
        }
    }
}

const XMenu = (props) => {
    const rootSubmenuKeys = props.navItems && props.navItems.map(obj => obj.sub);

    const [items, setItems] = useState([]);
    const [openKeys, setOpenKeys] = useState(getDefaultOpenKey(props.m, props.navItems));
    const [current, setCurrent] = useState(props.m.toString());

    useEffect(() => {
        var items = [];
        if (props.navItems) {
            for (var i = 0; i < props.navItems.length; i++) {
                var item = props.navItems[i];
                // 根据权限加载导航菜单
                if (props.btnLists.indexOf(item.ptn) >= 0) {
                    if (item['submenu'].toString() === '') {
                        // 一级菜单
                        items.push(getItem(item['name'], item['m'], icon(item['m'], props.nav)))
                    } else {
                        // 二级菜单
                        var subs_arr = []
                        for (var j = 0; j < item.submenu.length; j++) {
                            var sub_item = item.submenu[j];
                            if (props.btnLists.indexOf(sub_item.ptn) >= 0) {
                                subs_arr.push(getItem(sub_item['name'], sub_item['m']));
                            }
                        }
                        items.push(getItem(item['name'], item['sub'], icon(item['m'], props.nav), subs_arr))
                    }
                }
            }
            setItems(items);
        }

    }, [props.navItems, props.nav, props.btnLists]);

    const onOpenChange = (keys) => {
        const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
        if (latestOpenKey && rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
            setOpenKeys(keys);
        } else {
            setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
        }
    };
    const onClick = (e) => {
        if (e.key < 10) {
            setOpenKeys([]);
        }
        setCurrent(e.key);
        props.setM(e.key);
    };

    return (
        <Menu
            theme='dark'
            mode='inline'
            defaultSelectedKeys={['0']}
            openKeys={openKeys}
            onOpenChange={(keys) => onOpenChange(keys)}
            selectedKeys={[current]}
            onClick={(e) => onClick(e)}
            items={items}
        />
    );
}
export default XMenu;